// PowerScheduleCache.js
//
// Power schedules per rk, did = battery rk.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'PowerScheduleCache';

class PowerScheduleCache extends CacheBase2 {
    _name = _name;

    /**
     * @param {string} did - battery rk
     * @returns {object[]} schedules of this battery, sorted by start
     */
    getByDid = (did) => this.getAll().filter((s) => s.did === did).sort((a, b) => a.start - b.start);
}

const powerScheduleCache = new PowerScheduleCache();
export default powerScheduleCache;
